<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Match Results
          </div>
        </template>
        <template #actions v-if="!isTransactionInvalid">
          <ul>
            <li class="p-narrow no-border">
              <div class="list-content">
                <a
                  @click="refresh"
                  title="Refresh">
                  <font-awesome-icon :icon="['fas', 'sync-alt']" class="fa-lg"/>
                </a>
              </div>
            </li>
          </ul>
        </template>
      </es-header>
    </div>
    <div>
      <es-loader
        v-if="loading"
        style="margin: 3rem"
      />
      <es-exception
        v-else-if="showLoadingErrorMessage"
        class="exception-msg"
        :exceptionMessage="loadingErrorMessage"
      />
      <es-exception
        v-else-if="showDefaultLoadingError"
        class="exception-msg"
        exceptionMessage="There was an issue. Please try again or contact your administrator."
      />
      <es-exception
        v-else-if="showBatchInvalidMessage"
        class="exception-msg"
        exceptionMessage="Records must be submitted to view results."
      />
      <div
        v-else
        style="padding: .5rem 1.25rem .5rem 2rem"
      >
        <pid-batches-table
          v-if="batch && batch.id"
          :batches="[batch]"
        />
        <pid-transactions-table
          v-if="transaction"
          :transactions="[transaction]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import PidBatchesTable from '@/components/PidBatchesTable.vue';
import PidTransactionsTable from '@/components/PidTransactionsTable.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSyncAlt } from '@fortawesome/pro-solid-svg-icons';

library.add(
  faSyncAlt,
);

export default {
  components: {
    EsException,
    EsHeader,
    EsLoader,
    PidBatchesTable,
    PidTransactionsTable,
  },
  props: {
    batch: {
      type: Object,
    },
    transaction: {
      type: Object,
    },
    loadingTransactions: {
      type: Boolean,
      default: false,
    },
  },
  // No watcher needed for loadingTransactions, handled by computed property
  data() {
    return {
      loadingError: false,
      loadingErrorMessage: null,
    };
  },
  mounted() {
    this.$root.$on('matchOptionsLoadingError', this.setLoadingError);
    this.$root.$on('matchOptionsLoadingErrorMessage', this.setLoadingErrorMessage);
  },
  destroyed() {
    this.$root.$off('matchOptionsLoadingError');
    this.$root.$off('matchOptionsLoadingErrorMessage');
  },
  computed: {
    loading() {
      return this.loadingTransactions;
    },
    isBatchInvalid() {
      return this.batch === undefined || !this.batch.id;
    },
    isTransactionInvalid() {
      return this.transaction === undefined || !this.transaction.pidSubmissionId;
    },
    showBatchInvalidMessage() {
      return this.isBatchInvalid && this.isTransactionInvalid;
    },
    showDefaultLoadingError() {
      return this.loadingError && !this.loadingErrorMessage;
    },
    showLoadingErrorMessage() {
      return this.loadingErrorMessage && this.loadingError;
    },
  },
  methods: {
    setLoadingError(val) {
      this.loadingError = val;
    },
    setLoadingErrorMessage(val) {
      this.loadingErrorMessage = val;
    },
    refresh() {
      this.$emit('refresh');
    },
  },
};
</script>

<style lang="sass" scoped>
  .document
    padding: 0rem 0rem 0.01rem
  .exception-msg
    padding: 3rem
    margin: 0
</style>
